<script setup lang="ts">
import { useSettingStore } from '@/store/setting';
import { onBeforeMount } from 'vue';

const settingStore = useSettingStore();

onBeforeMount(() => {
  settingStore.getSettingInfo();
});

const handleDownload = () => {
  if (settingStore.settingInfo?.example_url) {
    window.open(settingStore.settingInfo.example_url, '_blank');
  }
};
</script>

<template>
  <div class="home">
    <img class="home__pic" draggable="false" src="@/assets/images/home/pic.png" alt="" />
    <div class="home__action">
      <img class="bg" draggable="false" src="@/assets/images/home/pic1.png" alt="" />
      <span class="home__action--label">与你萌享百变换装！</span>
      <div class="home__action--download" @click="handleDownload">
        <img class="bg" draggable="false" src="@/assets/images/home/download.png" alt="" />
        <span>人模素材下载</span>
      </div>
      <div class="home__action--intro">
        <router-link :to="{ name: 'ShopApplyGuide' }">装扮规范说明</router-link>
      </div>
    </div>
    <!-- 下载链接 -->
    <div class="home__qrcode">
      <div class="home__qrcode--code">
        <img src="https://moeisland.oss-cn-shanghai.aliyuncs.com/assets/default/ios.png" alt="" />
        <span>IOS下载</span>
      </div>
      <div class="home__qrcode--code">
        <img src="https://moeisland.oss-cn-shanghai.aliyuncs.com/assets/default/android.png" alt="" />
        <span>Android下载</span>
      </div>
      <div class="home__qrcode--code">
        <img src="https://moeisland.oss-cn-shanghai.aliyuncs.com/assets/default/wxmp.jpg" alt="" />
        <span>微信小程序扫码</span>
      </div>
    </div>
    <!-- 社区链接 -->
    <div class="home__link">
      <img draggable="false" src="@/assets/images/home/xiaohongshu.png" />
      <img draggable="false" src="@/assets/images/home/sina.png" />
      <img draggable="false" src="@/assets/images/home/douyin.png" />
      <img draggable="false" src="@/assets/images/home/wechat.png" />
      <img draggable="false" src="@/assets/images/home/qq.png" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  &__pic {
    position: absolute;
    left: 245px;
    top: 0;
    width: 562px;
  }
  &__action {
    position: absolute;
    right: 289px;
    top: 0;
    width: 770px;
    height: 320px;
    &--label {
      position: absolute;
      left: 176px;
      top: 170px;
      z-index: 1;
      font-weight: bolder;
      font-size: 50px;
      color: #333333;
    }
    &--download {
      position: absolute;
      left: 176px;
      bottom: 0px;
      width: 188px;
      height: 59px;
      user-select: none;
      cursor: pointer;
      > span {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        font-weight: 500;
        font-size: 18px;
        color: #ffffff;
        z-index: 1;
        padding-left: 19px;
        padding-bottom: 5px;
        box-sizing: border-box;
      }
    }
    &--intro {
      position: absolute;
      left: 395px;
      bottom: 4px;
      user-select: none;
      cursor: pointer;
      width: 181px;
      height: 52px;
      border: 1px solid #020202;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      font-size: 18px;
      color: #020202;
      > a {
        font-style: normal;
        text-decoration: none;
        color: #020202;
      }
    }
  }
  &__link {
    position: absolute;
    left: 1232px;
    bottom: 112px;
    width: 300px;
    height: 42px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    > img {
      width: 42px;
      height: 42px;
    }
  }
  &__qrcode {
    width: fit-content;
    position: absolute;
    left: 1000px;
    top: 400px;
    display: flex;
    gap: 50px;
    &--code {
      width: 150px;
      height: 150px;
      position: relative;
      > img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
      }
      > span {
        display: block;
        width: 100%;
        font-size: 14px;
        color: #333;
        text-align: center;
        position: absolute;
        font-weight: bold;
        left: 0;
        bottom: 0;
        transform: translateY(150%);
      }
    }
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  .home {
    height: 100%;
    min-height: 0;
    overflow: hidden;
    display: grid;
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
    grid-template-rows: auto auto 1fr;
    column-gap: 2rem;
    row-gap: 1.75rem;
    padding: 1.5rem 3rem 5.5rem;
    box-sizing: border-box;
    align-items: start;
  }

  .home__pic {
    position: static;
    grid-row: 1 / 3;
    align-self: start;
    justify-self: center;
    width: min(22rem, 38vw);
    margin-top: 0.25rem;
  }

  .home__action {
    position: relative;
    right: auto;
    top: auto;
    width: 100%;
    height: 13rem;
    margin-top: 0.25rem;

    > .bg {
      object-fit: contain;
      object-position: left center;
    }

    &--label {
      left: 4.4rem;
      top: 5.45rem;
      font-size: 1.9rem;
      white-space: nowrap;
    }

    &--download {
      left: 4.4rem;
      bottom: 0.8rem;
      width: 8.75rem;
      height: 2.75rem;

      > span {
        padding-left: 0.85rem;
        padding-bottom: 0.2rem;
        font-size: 0.875rem;
      }
    }

    &--intro {
      left: 14.5rem;
      bottom: 0.95rem;
      width: 8.75rem;
      height: 2.35rem;
      font-size: 0.875rem;
    }
  }

  .home__qrcode {
    position: static;
    grid-column: 2;
    width: 100%;
    display: flex;
    gap: 1.25rem;
    justify-content: flex-start;

    &--code {
      width: 6.5rem;
      height: 6.5rem;

      > span {
        font-size: 0.75rem;
        transform: translateY(135%);
      }
    }
  }

  .home__link {
    position: static;
    grid-column: 2;
    align-self: end;
    justify-self: end;
    width: 11.25rem;
    height: 1.75rem;

    > img {
      width: 1.75rem;
      height: 1.75rem;
    }
  }
}

@media (max-width: 767px) {
  .home {
    min-height: calc(100vh - 3.5rem);
    height: auto;
    overflow: visible;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1.35rem 1rem 5rem;
    box-sizing: border-box;
    gap: 1.25rem;
  }

  .home__action {
    order: 1;
    position: relative;
    right: auto;
    top: auto;
    width: min(100%, 24rem);
    height: 9.5rem;
    margin: 0 auto;

    > .bg {
      object-fit: contain;
      object-position: center;
    }

    &--label {
      left: 50%;
      top: 4rem;
      transform: translateX(-50%);
      width: max-content;
      max-width: 100%;
      font-size: 1.35rem;
      white-space: nowrap;
    }

    &--download {
      left: calc(50% - 8.6rem);
      bottom: 0.1rem;
      width: 8rem;
      height: 2.5rem;

      > span {
        padding-left: 0.75rem;
        padding-bottom: 0.15rem;
        font-size: 0.82rem;
      }
    }

    &--intro {
      left: calc(50% + 0.6rem);
      bottom: 0.25rem;
      width: 8rem;
      height: 2.15rem;
      font-size: 0.82rem;
    }
  }

  .home__pic {
    display: none;
  }

  .home__qrcode {
    order: 2;
    position: static;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: min(100%, 24rem);
    gap: 0.75rem;
    margin-top: 0.25rem;

    &--code {
      width: auto;
      height: auto;
      aspect-ratio: 1;
      border-radius: 0.5rem;

      > span {
        font-size: 0.68rem;
        line-height: 1.2;
        transform: translateY(130%);
      }
    }
  }

  .home__link {
    order: 3;
    position: static;
    width: 11rem;
    height: 1.65rem;
    margin-top: 1.75rem;

    > img {
      width: 1.65rem;
      height: 1.65rem;
    }
  }
}
</style>
